import { cn } from "@/lib/utils";
import type { WoRegenerateOutcomeLine } from "@/lib/use-wo-regenerate";
import type { regenerateProgressLine } from "@/lib/wo-regenerate";

export type WoRegenerateStatus = ReturnType<typeof regenerateProgressLine> | WoRegenerateOutcomeLine;

/**
 * The line under "WO — generated" that says what the regenerate is doing
 * (Issue #1413).
 *
 * A running regenerate counts up here instead of the screen going red at 30
 * seconds over work that succeeded; a settled one says how it went. Its own
 * component so the wording and the four tones are provable without rendering
 * the whole Close Out screen — and so the proof render is the real markup, not
 * a hand-written copy of it.
 */
export function WoRegenerateStatusLine({ status }: { status: WoRegenerateStatus | null }) {
    if (!status) return null;
    const running = "slow" in status;
    return (
        <p
            className={cn(
                "ml-[27px] pb-1 pr-1 text-[11px] leading-snug",
                running
                    ? "text-sky-700 dark:text-sky-300"
                    : status.tone === "ok"
                      ? "text-emerald-700 dark:text-emerald-400"
                      : status.tone === "warn"
                        ? "text-amber-700 dark:text-amber-400"
                        : "text-red-700 dark:text-red-400",
            )}
        >
            {status.text}
        </p>
    );
}
